
const RegisterHtmlTemplate = require('polymer-webpack-loader/register-html-template');

RegisterHtmlTemplate.register("<dom-module id=wia-video-popup> <template> <style include=shared-style></style> <style>" + require("./wia-video-popup.css") + "</style> <aofl-drawer open=\"\"> <abcmouse-video src$=[[video]] next-modal=wiaProspect></abcmouse-video> </aofl-drawer> </template> </dom-module>");



// WEBPACK FOOTER //
// ./home/en-US/js/wia-video-popup/wia-video-popup.html